import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51e750c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "NewMap" }
const _hoisted_2 = {
  key: 0,
  class: "NewMap__state"
}
const _hoisted_3 = { class: "text-red-500" }
const _hoisted_4 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isRenderingState)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_loader, { class: "primary" }),
                _createElementVNode("p", null, _toDisplayString(_ctx.loadingText), 1)
              ], 64))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.failedText), 1),
                  _createVNode(_component_the_button, { class: "primary small mt-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.failedButtonText), 1)
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("section", { id: _ctx.id }, null, 8, _hoisted_4), [
      [_vShow, !_ctx.isRenderingState]
    ])
  ]))
}